import React, {useContext} from 'react';

import WishibamLogo from "./components/WishibamLogo";
import Profile from "./components/Profile";
import LogoutButton from "./components/LogoutButton";
import Applications from "./components/Applications";
import OrganizationSelector from "./components/OrganizationSelector";
import SidebarMenus from "./components/SidebarMenus";
import Inventory from "./components/Inventory";
import SidebarBottomContainer from "./components/SidebarBottomContainer";
import EnvironmentWarning from "./components/EnvironmentWarning";
import MobileCurrentOrganization from "./components/MobileCurrentOrganization";
import ScrollableContainer from "./components/ScrollableContainer";

import {SidebarContext} from "../../SidebarContext";

import {APPLICATIONS} from "utils/Applications";
import Retailers from "./components/Retailers";

function SidebarContent(props) {
    const {selectedApplication, isMobile} = useContext(SidebarContext);

    const isPreprodOrSandbox = ['preprod', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT)

    if (!isMobile) {
        return (
            <React.Fragment>
                <EnvironmentWarning />
                <div style={{
                    borderRadius: !isPreprodOrSandbox ? '' : '8px 8px 0 0',
                    background: 'white',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflow: 'hidden',
                }}>
                    <WishibamLogo />
                    <OrganizationSelector/>
                    <ScrollableContainer>
                        <Retailers />
                        <SidebarMenus />
                        {selectedApplication === APPLICATIONS.WMS && (
                            <Inventory/>
                        )}
                    </ScrollableContainer>
                    <SidebarBottomContainer>
                        <Applications/>
                        <Profile/>
                    </SidebarBottomContainer>
                </div>
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                <EnvironmentWarning />
                <ScrollableContainer>
                    <OrganizationSelector />
                    <Retailers />
                    <SidebarMenus />
                    {selectedApplication === APPLICATIONS.WMS && (
                        <Inventory />
                    )}
                    <SidebarBottomContainer>
                        <Applications />
                        <Profile />
                    </SidebarBottomContainer>
                </ScrollableContainer>
            </React.Fragment>
        );
    }
}

export default SidebarContent;
